module.exports = __webpack_public_path__ + "img/bkl4.ad9b65e1.jpg";